export default __webpack_public_path__ + "static/media/about.0e22f8e0.svg";